module.exports = {"noData":"Data nejsou k dispozici"}